import { Collapse, Flex, Icon, Text } from '@chakra-ui/react';
import { saveAs } from 'file-saver';
import { useContext, useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';

import { MediaContext, MediaContextType } from '../../../../hooks/useMediaCollection';
import DocListItem from '../documents/DocListItem';

const UploadHistorySection = () => {
  const [open, setOpen] = useState(false);
  const { customerUploadedMedia } = useContext<MediaContextType>(MediaContext);

  return (
    <>
      <Flex as="button" alignItems="center" w="full" onClick={() => setOpen((prev) => !prev)}>
        <Icon
          transform={open ? 'rotate(90deg)' : 'rotate(0deg)'}
          transition="transform 0.3s ease"
          as={FaChevronRight}
          mr={2}
          fontSize="sm"
        />
        <Text fontWeight="semibold">UPLOAD HISTORY ({customerUploadedMedia.length})</Text>
      </Flex>
      <Collapse in={open} animateOpacity>
        <Flex pt={2} flexDir="column">
          {customerUploadedMedia.length === 0 ? (
            <Text fontSize="sm" color="gray.500" pl={6}>
              No downloads at this time
            </Text>
          ) : (
            customerUploadedMedia
              .filter((mediaItem) => !!mediaItem.signed_url)
              .map((mediaItem) => {
                const parts = mediaItem?.key?.split('.') ?? [];
                const ext = parts[parts.length - 1];
                return (
                  <DocListItem
                    key={mediaItem.key}
                    media={mediaItem}
                    onDownloadClick={() =>
                      saveAs(mediaItem.signed_url as string, `${mediaItem.type}.${ext}`)
                    }
                    downloading={false}
                  />
                );
              })
          )}
        </Flex>
      </Collapse>
    </>
  );
};

export default UploadHistorySection;
